import {combineReducers} from '@reduxjs/toolkit'
import brandReducer from './brand.reducer'
import labelsReducer from './labels.reducer'
import modalReducer from './modal.reducer'
import orderConfigReducer from './settings.reducer'
import orderDetailsReducer from './order_details.reducer'
import themeReducer from './theme.reducer'

const rootReducer = combineReducers({
  modal: modalReducer,
  labels: labelsReducer,
  orderDetails: orderDetailsReducer,
  settings: orderConfigReducer,
  brand: brandReducer,
  theme: themeReducer,
})
export default rootReducer
